import type { Resource } from '../../';
export const forms_address_zipCode: Resource = {"default":"Zip Code"};
